/* LITS — Find Your Flavour quiz enhancement
   On the quiz result this adds:
     1. A product card (photo, tagline subtitle, price, add-to-cart -> cart drawer, view product)
     2. Two share buttons that render the result as a branded "Flavour Horoscope" image:
        "Add to your story" (9:16) and "Send to a friend" (4:5)
   Loaded only on the find-your-flavour template. Reads the result from the DOM and fetches live
   product data, so it does not modify the quiz section itself. */
(function () {
  if (window.__litsQuizEnhance) return;
  window.__litsQuizEnhance = true;

  var GOLD = '#FDD100', GOLDSOFT = 'rgba(248,194,9,0.55)', MAROON = '#5e0c0c', WHITE = '#ffffff', CREAM = '#f6e8c4';
  var JF = "'Jost','Futura PT',Arial,sans-serif", FF = "'Fraunces',Georgia,serif";
  var PATTERN_URL = 'https://cdn.shopify.com/s/files/1/0001/8222/2880/files/LITS_x_WB_Pattern.png?v=1782671714&width=1080';
  var BADGE_URL = 'https://cdn.shopify.com/s/files/1/0001/8222/2880/files/LITS-badge-white_3x_84003172-d81d-48b2-9728-fe256c73c8db.png?v=1781460108&width=560';

  /* Taglines mirror each product's PDP section setting (they are NOT a metafield, so they live here).
     If you reword a tagline on a product page, update the matching line below. Keyed by product handle. */
  var TAGLINES = {
    'ammas-malaysian-sambal': "Some flavours feed you. This one feels like you're being looked after.",
    'og-boodoo': "7/10 heat. 10/10 flavour. Built for everything.",
    'burning-mango': "The mango hot sauce where you can actually taste the mango.",
    'project-casper': "The LITS take on hot honey garlic, Canadian-style.",
    'bodhi': "Sanskrit for awakening. A hot sauce that tastes like enlightenment.",
    'lime-chili': "Salsa verde that'll have you rethinking whether taco night is just for Tuesdays.",
    'lits-flavour-flight': "Three sauces. Three heat levels. Zero excuses for bland travel food."
  };

  /* Display strings come from window.LITS_QUIZ_I18N (set by the quiz section via the theme locales);
     English fallbacks keep this file working if that object is missing. */
  function T(k, fb) { var I = window.LITS_QUIZ_I18N; return (I && I[k]) || fb; }
  function fill(str, k, v) { return str.replace(k, function () { return v; }); }
  function tagline(h) { var I = window.LITS_QUIZ_I18N, t = I && I.taglines; return (h && ((t && t[h]) || TAGLINES[h])) || ''; }

  function money(cents) {
    var n = (cents / 100).toFixed(2), d = T('decimal', ''), f = T('price', '');
    if (d) n = n.replace('.', d);
    return f ? fill(f, '%n', n) : '$' + n;
  }
  function setLS(x, px) { try { x.letterSpacing = px + 'px'; } catch (e) {} }
  function clrLS(x) { try { x.letterSpacing = '0px'; } catch (e) {} }

  function injectStyles() {
    if (document.getElementById('lits-fyfx-style')) return;
    var s = document.createElement('style');
    s.id = 'lits-fyfx-style';
    s.textContent =
      '.fyfx-card{display:flex;gap:16px;align-items:center;margin:16px 0 4px;padding:14px;background:#fff;border:2px solid #efece4;border-radius:12px;}' +
      '.fyfx-card img.fyfx-bottle{width:84px;height:84px;flex:0 0 84px;object-fit:contain;background:#faf7f0;border-radius:9px;}' +
      '.fyfx-info{flex:1;min-width:0;text-align:left;}' +
      '.fyfx-eyebrow{font-size:10.5px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;color:#721010;margin:0 0 3px;}' +
      '.fyfx-title{font-size:17px;font-weight:800;color:#111;margin:0 0 3px;line-height:1.15;}' +
      '.fyfx-tag{font-size:13px;font-style:italic;color:#6a6a6a;margin:0 0 8px;line-height:1.3;}' +
      '.fyfx-price{font-size:14px;font-weight:700;color:#3f3d38;margin:0 0 10px;}' +
      '.fyfx-actions{display:flex;gap:9px;flex-wrap:wrap;}' +
      '.fyfx-atc{flex:1;min-width:130px;background:' + GOLD + ';color:#111;border:2px solid ' + GOLD + ';font-family:inherit;font-weight:800;font-size:13px;letter-spacing:.6px;text-transform:uppercase;padding:11px 14px;border-radius:7px;cursor:pointer;transition:background-color .2s,color .2s,border-color .2s;}' +
      '.fyfx-atc:hover{background:#111;color:' + GOLD + ';border-color:#111;}' +
      '.fyfx-atc[disabled]{opacity:.6;cursor:default;}' +
      '.fyfx-view{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;background:#fff;color:#111;border:2px solid #111;font-weight:800;font-size:13px;letter-spacing:.6px;text-transform:uppercase;padding:11px 14px;border-radius:7px;text-decoration:none;transition:background-color .2s,color .2s;}' +
      '.fyfx-view:hover{background:#111;color:#fff;}' +
      '.fyfx-share-wrap{margin-top:16px;display:flex;flex-direction:column;gap:9px;align-items:center;}' +
      '.fyfx-sharebtn{width:100%;max-width:320px;font-family:inherit;font-weight:800;font-size:13px;letter-spacing:.8px;text-transform:uppercase;padding:13px 20px;border-radius:8px;cursor:pointer;transition:background-color .2s,color .2s,border-color .2s;}' +
      '.fyfx-share-story{background:' + GOLD + ';color:#111;border:2px solid ' + GOLD + ';}' +
      '.fyfx-share-story:hover{background:#111;color:' + GOLD + ';border-color:#111;}' +
      '.fyfx-share-chat{background:#111;color:#fff;border:2px solid #111;}' +
      '.fyfx-share-chat:hover{background:' + GOLD + ';color:#111;border-color:' + GOLD + ';}' +
      '.fyfx-sharebtn[disabled]{opacity:.6;cursor:default;}' +
      '.fyfx-note{font-size:12.5px;color:#8a877f;margin:6px 0 0;text-align:center;}' +
      '@media(max-width:480px){.fyfx-card{flex-direction:column;text-align:center;align-items:center;}.fyfx-info{text-align:center;}.fyfx-actions{justify-content:center;}}';
    document.head.appendChild(s);
  }

  function handleFromShop(root) {
    var a = root.querySelector('.fyf-r-shop');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function openCartDrawer() {
    try {
      if (window.wetheme) {
        if (typeof wetheme.updateCartDrawer === 'function') wetheme.updateCartDrawer();
        if (typeof wetheme.toggleRightDrawer === 'function' && !document.body.classList.contains('js-drawer-open')) {
          wetheme.toggleRightDrawer();
        }
        return true;
      }
    } catch (e) {}
    return false;
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
  }

  function buildCard(root, product) {
    var match = root.querySelector('.fyf-match');
    if (!match || match.querySelector('.fyfx-card')) return;
    var variant = (product.variants || []).filter(function (v) { return v.available; })[0] || (product.variants || [])[0];
    var img = product.featured_image || (product.images && product.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img = img.split('?')[0] + '?width=200';

    var oldBtn = match.querySelector('.fyf-r-shop');
    var pdp = oldBtn ? oldBtn.getAttribute('href') : ('/products/' + product.handle);
    var tag = tagline(product.handle);

    var card = document.createElement('div');
    card.className = 'fyfx-card';
    card.innerHTML =
      (img ? '<img class="fyfx-bottle" src="' + img + '" alt="' + (product.title || '') + '" loading="lazy">' : '') +
      '<div class="fyfx-info">' +
        '<p class="fyfx-eyebrow">' + T('your_sauce', 'Your sauce &middot; Lost in the Sauce') + '</p>' +
        '<p class="fyfx-title">' + (product.title || '') + '</p>' +
        (tag ? '<p class="fyfx-tag">' + tag + '</p>' : '') +
        '<p class="fyfx-price">' + (variant ? money(variant.price) : '') + '</p>' +
        '<div class="fyfx-actions">' +
          '<button type="button" class="fyfx-atc">' + T('add_to_cart', 'Add to cart') + '</button>' +
          '<a class="fyfx-view" href="' + pdp + '">' + T('view', 'View') + '</a>' +
        '</div>' +
      '</div>';

    if (oldBtn) { oldBtn.style.display = 'none'; match.insertBefore(card, oldBtn); }
    else { match.appendChild(card); }

    var atc = card.querySelector('.fyfx-atc');
    atc.addEventListener('click', function () {
      if (!variant) { window.location.href = pdp; return; }
      atc.setAttribute('disabled', 'disabled');
      atc.textContent = T('adding', 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        atc.textContent = T('added', 'Added ✓');
        refreshCartCount();
        openCartDrawer();
        var actions = card.querySelector('.fyfx-actions');
        if (actions && !actions.querySelector('.fyfx-viewcart')) {
          var vc = document.createElement('a');
          vc.className = 'fyfx-view fyfx-viewcart';
          vc.href = '/cart';
          vc.textContent = T('view_cart', 'View cart →');
          actions.appendChild(vc);
        }
        setTimeout(function () { atc.removeAttribute('disabled'); atc.textContent = T('add_to_cart', 'Add to cart'); }, 2500);
      }).catch(function () {
        atc.removeAttribute('disabled');
        atc.textContent = T('add_to_cart', 'Add to cart');
        window.location.href = pdp;
      });
    });
  }

  /* ---------- share image ("Flavour Horoscope" card) ---------- */
  function wrap(x, t, max) {
    var w = (t || '').split(/\s+/), L = [], ln = '';
    for (var i = 0; i < w.length; i++) {
      var tt = ln ? ln + ' ' + w[i] : w[i];
      if (x.measureText(tt).width > max && ln) { L.push(ln); ln = w[i]; } else { ln = tt; }
    }
    if (ln) L.push(ln);
    return L;
  }
  function wrapTidy(x, t, max) {
    var L = wrap(x, t, max);
    if (L.length >= 2) {
      var last = L[L.length - 1].split(' ');
      if (last.length === 1) {
        var p = L[L.length - 2].split(' ');
        if (p.length > 1) {
          var mv = p.pop();
          var nl = mv + ' ' + L[L.length - 1];
          if (x.measureText(nl).width <= max) { L[L.length - 2] = p.join(' '); L[L.length - 1] = nl; }
        }
      }
    }
    return L;
  }
  function rrp(x, a, b, w, h, r) { x.beginPath(); x.moveTo(a + r, b); x.arcTo(a + w, b, a + w, b + h, r); x.arcTo(a + w, b + h, a, b + h, r); x.arcTo(a, b + h, a, b, r); x.arcTo(a, b, a + w, b, r); x.closePath(); }
  function circleImg(x, img, cx, cy, r) { x.save(); x.beginPath(); x.arc(cx, cy, r, 0, 7); x.closePath(); x.clip(); x.drawImage(img, cx - r, cy - r, r * 2, r * 2); x.restore(); }
  function spark(x, cx, cy, s) { x.save(); x.fillStyle = GOLD; x.beginPath(); x.moveTo(cx, cy - s); x.quadraticCurveTo(cx + s * 0.2, cy - s * 0.2, cx + s, cy); x.quadraticCurveTo(cx + s * 0.2, cy + s * 0.2, cx, cy + s); x.quadraticCurveTo(cx - s * 0.2, cy + s * 0.2, cx - s, cy); x.quadraticCurveTo(cx - s * 0.2, cy - s * 0.2, cx, cy - s); x.closePath(); x.fill(); x.restore(); }

  function loadImg(src) { return new Promise(function (r) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { r(i); }; i.onerror = function () { r(null); }; i.src = src; }); }
  function avatarToImage(root) {
    var svg = root.querySelector('.fyf-r-av svg');
    if (!svg) return Promise.resolve(null);
    try {
      var clone = svg.cloneNode(true);
      clone.setAttribute('width', '240'); clone.setAttribute('height', '240');
      var xml = new XMLSerializer().serializeToString(clone);
      return loadImg('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml));
    } catch (e) { return Promise.resolve(null); }
  }
  var _assets = null;
  function getAssets() {
    if (_assets) return _assets;
    _assets = Promise.all([loadImg(PATTERN_URL), loadImg(BADGE_URL)]).then(function (r) { return { pat: r[0], badge: r[1] }; });
    return _assets;
  }

  var NINE = { W: 1080, H: 1920, m: 34, frameR: 30, badge: 320, badgeY: 250, hf: 46, handleY: 620, kf: 50, kickY: 712, avY: 828, avR: 84, nf: 84, nameY: 998, ruleY: 1030, ruleW: 140, qf: 60, qlh: 88, qpad: 230, quoteCY: 1185, qmk: 148, pf: 38, pillY: 1334, pillH: 74, tf: 30, tagY: 1452, tagLH: 38, tagPad: 180, cf: 34, ctaGap: 60 };
  var FOUR = { W: 1080, H: 1350, m: 28, frameR: 24, badge: 236, badgeY: 60, hf: 38, handleY: 344, kf: 42, kickY: 436, avY: 576, avR: 76, nf: 64, nameY: 730, ruleY: 760, ruleW: 118, qf: 48, qlh: 68, qpad: 190, quoteCY: 912, qmk: 118, pf: 32, pillY: 1066, pillH: 62, tf: 26, tagY: 1166, tagLH: 32, tagPad: 150, cf: 26, ctaGap: 52 };

  function drawCard(S, a, data) {
    var W = S.W, H = S.H;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d');
    var pat = a.pat, badge = a.badge, av = data.av;
    var vg = x.createRadialGradient(W / 2, H * 0.46, 120, W / 2, H * 0.5, H * 0.66);
    vg.addColorStop(0, '#741414'); vg.addColorStop(1, '#4a0707');
    x.fillStyle = vg; x.fillRect(0, 0, W, H);
    if (pat) { var sc = 1.75, dw = W * sc, dh = dw * (pat.height / pat.width); x.save(); x.globalAlpha = 0.22; x.globalCompositeOperation = 'luminosity'; x.drawImage(pat, (W - dw) / 2, (H - dh) / 2, dw, dh); x.restore(); }
    x.save(); x.globalAlpha = 0.22; x.fillStyle = MAROON; x.fillRect(0, 0, W, H); x.restore();

    var m = S.m;
    rrp(x, m, m, W - 2 * m, H - 2 * m, S.frameR); x.lineWidth = 3; x.strokeStyle = GOLDSOFT; x.stroke();
    rrp(x, m + 12, m + 12, W - 2 * m - 24, H - 2 * m - 24, S.frameR - 9); x.lineWidth = 1.4; x.strokeStyle = 'rgba(248,194,9,0.28)'; x.stroke();

    x.textAlign = 'center';
    if (badge) { circleImg(x, badge, W / 2, S.badgeY + S.badge / 2, S.badge / 2); }
    x.fillStyle = GOLD; x.font = '700 ' + S.hf + 'px ' + JF; setLS(x, 2); x.fillText('@litssauce', W / 2, S.handleY); clrLS(x);
    x.fillStyle = GOLD; x.font = '700 ' + S.kf + 'px ' + JF; setLS(x, 6);
    var kt = T('horoscope', 'FLAVOUR HOROSCOPE'); x.fillText(kt, W / 2, S.kickY); var ktw = x.measureText(kt).width; clrLS(x);
    spark(x, W / 2 - ktw / 2 - 46, S.kickY - S.kf * 0.34, 16); spark(x, W / 2 + ktw / 2 + 46, S.kickY - S.kf * 0.34, 16);

    if (av) { circleImg(x, av, W / 2, S.avY, S.avR); x.lineWidth = 9; x.strokeStyle = GOLD; x.beginPath(); x.arc(W / 2, S.avY, S.avR, 0, 7); x.stroke(); }
    spark(x, W / 2 - S.avR - 44, S.avY - S.avR * 0.5, 13); spark(x, W / 2 + S.avR + 44, S.avY - S.avR * 0.5, 13);

    x.fillStyle = WHITE; x.font = '900 ' + S.nf + 'px ' + JF; x.fillText((data.persona || '').toUpperCase(), W / 2, S.nameY);
    x.strokeStyle = GOLD; x.lineWidth = 4; x.beginPath(); x.moveTo(W / 2 - S.ruleW / 2, S.ruleY); x.lineTo(W / 2 + S.ruleW / 2, S.ruleY); x.stroke();

    x.font = 'italic 400 ' + S.qf + 'px ' + FF;
    var ql = wrapTidy(x, data.fortune, W - S.qpad);
    var total = ql.length * S.qlh, first = S.quoteCY - total / 2 + S.qf * 0.72;
    var qTop = first - S.qf * 0.8, qBot = first + (ql.length - 1) * S.qlh + S.qf * 0.2;
    x.fillStyle = GOLD; x.font = '400 ' + S.qmk + 'px ' + FF;
    x.textAlign = 'left'; x.fillText('“', m + 58, qTop + S.qmk * 0.34);
    x.textAlign = 'right'; x.fillText('”', W - m - 58, qBot + S.qmk * 0.30);
    x.textAlign = 'center';
    x.fillStyle = WHITE; x.font = 'italic 400 ' + S.qf + 'px ' + FF;
    for (var i = 0; i < ql.length; i++) { x.fillText(ql[i], W / 2, first + i * S.qlh); }

    x.fillStyle = GOLD; x.font = '900 ' + S.pf + 'px ' + JF;
    var sauceUp = (data.sauce || '').toUpperCase();
    var pw = x.measureText(sauceUp).width + 78;
    rrp(x, (W - pw) / 2, S.pillY, pw, S.pillH, S.pillH / 2); x.fill();
    x.fillStyle = MAROON; x.fillText(sauceUp, W / 2, S.pillY + S.pillH * 0.67);

    var ctaY = S.tagY + S.ctaGap;
    if (data.tagline) {
      x.fillStyle = CREAM; x.font = '400 ' + S.tf + 'px ' + JF;
      var tl = wrap(x, data.tagline, W - S.tagPad);
      for (var t = 0; t < tl.length; t++) { x.fillText(tl[t], W / 2, S.tagY + t * S.tagLH); }
      ctaY = S.tagY + (tl.length - 1) * S.tagLH + S.ctaGap;
    }

    x.fillStyle = WHITE; x.font = '700 ' + S.cf + 'px ' + JF; setLS(x, 2);
    x.fillText('LOST IN THE SAUCE   ·   lostinthesauce.ca', W / 2, ctaY); clrLS(x);
    return c;
  }

  function renderShareBlob(root, ratio) {
    var ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    return Promise.all([getAssets(), avatarToImage(root), ready]).then(function (r) {
      var assets = r[0], av = r[1];
      var handle = handleFromShop(root);
      var data = {
        persona: (root.querySelector('.fyf-r-name') || {}).textContent || '',
        sauce: (root.querySelector('.fyf-r-sauce') || {}).textContent || '',
        fortune: (root.querySelector('.fyf-r-fortune') || {}).textContent || '',
        tagline: tagline(handle),
        av: av
      };
      var canvas = drawCard(ratio === 'story' ? NINE : FOUR, assets, data);
      return new Promise(function (res) { canvas.toBlob(function (b) { res(b); }, 'image/png'); });
    });
  }

  function doShare(root, ratio, btn, note) {
    var old = btn.textContent; btn.disabled = true; btn.textContent = T('creating', 'Creating…');
    renderShareBlob(root, ratio).then(function (blob) {
      btn.disabled = false; btn.textContent = old;
      if (!blob) { note.textContent = fill(T('img_error', 'Could not create the image. Copy your link: %url'), '%url', location.href); return; }
      var name = (root.querySelector('.fyf-r-name') || {}).textContent || T('name_fallback', 'my flavour');
      var file = new File([blob], 'lits-flavour-match.png', { type: 'image/png' });
      var shareData = { title: T('share_title', 'My LITS flavour match'), text: fill(fill(T('share_text_img', "I'm %name on the LITS flavour quiz. Find yours: %url"), '%name', name), '%url', location.href) };
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        shareData.files = [file];
        navigator.share(shareData).catch(function () {});
      } else {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url; a.download = 'lits-flavour-' + ratio + '.png';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
        note.textContent = fill(T('img_saved', 'Image saved. Share it anywhere, or copy your link: %url'), '%url', location.href);
      }
    }).catch(function () { btn.disabled = false; btn.textContent = old; });
  }

  function setupShare(root) {
    var links = root.querySelector('.fyf-result .fyf-links');
    if (links) links.style.display = 'none';
    var host = root.querySelector('.fyf-result .fyf-pad');
    if (!host || host.querySelector('.fyfx-share-wrap')) return;

    var wrapEl = document.createElement('div');
    wrapEl.className = 'fyfx-share-wrap';
    var b1 = document.createElement('button'); b1.type = 'button'; b1.className = 'fyfx-sharebtn fyfx-share-story'; b1.textContent = T('story_btn', 'Add to your story');
    var b2 = document.createElement('button'); b2.type = 'button'; b2.className = 'fyfx-sharebtn fyfx-share-chat'; b2.textContent = T('friend_btn', 'Send to a friend');
    var note = document.createElement('p'); note.className = 'fyfx-note'; note.textContent = '';
    wrapEl.appendChild(b1); wrapEl.appendChild(b2); wrapEl.appendChild(note);
    host.appendChild(wrapEl);
    b1.addEventListener('click', function () { doShare(root, 'story', b1, note); });
    b2.addEventListener('click', function () { doShare(root, 'chat', b2, note); });
  }

  function enhance(root) {
    var sauceEl = root.querySelector('.fyf-r-sauce');
    if (!sauceEl || !sauceEl.textContent.trim()) return;
    var handle = handleFromShop(root);
    if (!handle) return;
    injectStyles();
    setupShare(root);
    if (root.dataset.fyfxHandle === handle) return;
    root.dataset.fyfxHandle = handle;
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) { buildCard(root, product); })
      .catch(function () {});
  }

  function watch() {
    document.querySelectorAll('[id^="fyf-"]').forEach(function (root) {
      var res = root.querySelector('.fyf-result');
      if (!res) return;
      var run = function () { if (!res.classList.contains('fyf-hide')) enhance(root); };
      var mo = new MutationObserver(run);
      mo.observe(res, { attributes: true, attributeFilter: ['class'] });
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else { watch(); }
})();
